import * as React from 'react';
import PropTypes from 'prop-types';

function QuestionIcon(props) {
  return (
    <svg
      className={props.className}
      viewBox="0 0 16 16"
      width={props.width}
      height={props.height}>
      <g data-name="Layer 2">
        <path fill="none" d="M0 0h16v16H0z" />
        {/* Ring: outer circle with the inner circle knocked out via evenodd. */}
        <path
          fillRule="evenodd"
          d="M8 .6A7.4 7.4 0 108 15.4 7.4 7.4 0 008 .6zm0 1.5A5.9 5.9 0 118 13.9 5.9 5.9 0 018 2.1z"
          fill={props.tintColor}
        />
        {/* Question mark hook and stem. */}
        <path
          d="M8.02 3.5c-1.53 0-2.63.86-2.86 2.2a.6.6 0 00.55.72h.5a.6.6 0 00.6-.45c.13-.5.55-.87 1.19-.87.7 0 1.16.4 1.16.98 0 .5-.25.79-.86 1.2-.72.47-1.06.95-1.02 1.79v.13a.5.5 0 00.5.48h.5a.5.5 0 00.5-.5c0-.5.2-.78.83-1.19.74-.48 1.16-1.02 1.16-1.93 0-1.4-1.13-2.56-2.75-2.56z"
          fill={props.tintColor}
        />
        <circle cx="8" cy="11.6" r="0.95" fill={props.tintColor} />
      </g>
    </svg>
  );
}

QuestionIcon.defaultProps = {
  width: 24,
  height: 24,
  tintColor: 'var(--primary)',
};

QuestionIcon.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tintColor: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default QuestionIcon;
